const REFERENCE_FONT_SIZE = 100
const FONT_FAMILY = '"Roboto Mono", monospace'
const FALLBACK_CHARACTER_WIDTH_RATIO = 0.6

const measuredTextWidths = new Map()
let measurementContext = null

const getMeasurementContext = function () {
  if (measurementContext || typeof document === 'undefined') {
    return measurementContext
  }

  const canvas = document.createElement('canvas')
  measurementContext = canvas.getContext('2d')

  if (measurementContext) {
    measurementContext.font = `${REFERENCE_FONT_SIZE}px ${FONT_FAMILY}`
  }

  return measurementContext
}

const measureTextWidth = function (text) {
  if (measuredTextWidths.has(text)) {
    return measuredTextWidths.get(text)
  }

  const context = getMeasurementContext()
  const width = context
    ? context.measureText(text).width
    : text.length * REFERENCE_FONT_SIZE * FALLBACK_CHARACTER_WIDTH_RATIO

  measuredTextWidths.set(text, width)
  return width
}

/**
 * Fits a label inside an SVG rectangle using SVG user units.
 * Measurements are cached and never need to be repeated while the map zooms.
 */
export const svgTextFontSize = function (text, width, height, options = {}) {
  const label = String(text ?? '')
  const widthRatio = options.widthRatio ?? 0.85
  const heightRatio = options.heightRatio ?? 0.7

  if (!label || width <= 0 || height <= 0) {
    return 0
  }

  const measuredWidth = measureTextWidth(label)

  return Math.min(
    height * heightRatio,
    width * widthRatio * REFERENCE_FONT_SIZE / measuredWidth
  )
}
